/**
 * The inbox rule request status which is used to show the inbox
 * rule dialog based on the current state
 */
var InboxRuleRequestStatus;
(function (InboxRuleRequestStatus) {
    InboxRuleRequestStatus[InboxRuleRequestStatus["NotInitiated"] = 0] = "NotInitiated";
    InboxRuleRequestStatus[InboxRuleRequestStatus["Pending"] = 1] = "Pending";
    InboxRuleRequestStatus[InboxRuleRequestStatus["Complete"] = 2] = "Complete";
    InboxRuleRequestStatus[InboxRuleRequestStatus["Error"] = 3] = "Error";
})(InboxRuleRequestStatus || (InboxRuleRequestStatus = {}));
export default InboxRuleRequestStatus;
//# sourceMappingURL=InboxRuleRequestStatus.js.map